var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79971 1.60636C6.42812 1.01287 5.43313 0.0731818 4.80472 0.716126L0.196378 5.01891C-0.0654595 5.2662 -0.0654595 5.71131 0.196378 5.9586L4.80472 10.3108C5.43313 10.9043 6.42812 9.96464 5.79971 9.37115L1.71504 5.51348L5.79971 1.60636Z",
    fill: "#333232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.0b9bf5be95b6968a97767c853b96d6ba.svg";
export { ForwardRef as ReactComponent };